<template>
  <b-row v-if="reordering">
    <b-col cols="12" class="d-flex justify-content-between flex-wrap mb-1">
      <div v-if="entityEditable" class="d-flex align-items-center">
        <span>Show</span>
        <div class="custom-dropdown-dynamic pagin px-1">
          <v-select
            v-model="paginationConfig.perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
            :options="paginationConfig.perPageOptions"
            class="entity-filter"
            @input="$emit('entityChange', paginationConfig.perPage)"
          />
        </div>
        <span class="mr-1">Entities</span>
      </div>
      <reorder-button :mode="reorderMode" @click.native="onClickReorder" />
    </b-col>
    <b-col cols="12" class="d-flex justify-content-end align-item-center">
      <b-pagination
        v-model="paginationConfig.currentPage"
        :total-rows="paginationConfig.totalRows"
        :per-page="paginationConfig.perPage"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0 pagination-with-reorder"
        prev-class="prev-item"
        next-class="next-item"
        @input="$emit('pageChange', paginationConfig.currentPage)"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
      <b-form @submit.prevent="searchPagination" v-if="paginationSearch">
        <div id="pagin-search" class="d-flex align-items-center ml-4">
          <span class="mr-2 font-label">Go to</span>
          <div class="pagin">
            <b-input-group class="">
              <b-form-input
                v-model="paginationSearchInput"
                id="ref"
                class="input-wrp w-100"
                @input="onInputPaginationSearch"
              />
              <b-input-group-append>
                <b-button class="" type="submit">
                  <span class="" role="status" aria-hidden="true" />
                  <div class="fas fa-search" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <span class="ml-2 font-label">Page</span>
        </div>
      </b-form>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col
      cols="12"
      class="d-flex flex-wrap"
      :class="
        entityEditable ? 'justify-content-between' : 'justify-content-end'
      "
    >
      <div v-if="entityEditable" class="d-flex align-items-center">
        <span>Show</span>
        <div class="custom-dropdown-dynamic pagin px-1">
          <v-select
            v-model="paginationConfig.perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
            :options="paginationConfig.perPageOptions"
            class="entity-filter"
            @input="$emit('entityChange', paginationConfig.perPage)"
          />
        </div>
        <span class="mr-1">Entities</span>
      </div>
      <div class="d-flex justify-content-center align-item-center">
        <b-pagination
          v-model="paginationConfig.currentPage"
          :total-rows="paginationConfig.totalRows"
          :per-page="paginationConfig.perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0 pagination-with-reorder"
          prev-class="prev-item"
          next-class="next-item"
          @input="$emit('pageChange', paginationConfig.currentPage)"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
        <b-form @submit.prevent="searchPagination" v-if="paginationSearch">
          <div id="pagin-search" class="d-flex align-items-center ml-4">
            <span class="mr-2 font-label">Go to</span>
            <div class="pagin">
              <b-input-group class="">
                <b-form-input
                  v-model="paginationSearchInput"
                  id="ref"
                  class="input-wrp w-100"
                  @input="onInputPaginationSearch"
                />
                <b-input-group-append>
                  <b-button class="" type="submit">
                    <span class="" role="status" aria-hidden="true" />
                    <div class="fas fa-search" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <span class="ml-2 font-label">Page</span>
          </div>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BPagination, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import ReorderIcon from "@/@core/components/svg/common/Reorder.vue";
import ReorderButton from "@/views/components/button/ReorderButton.vue";

import {
  reactive,
  ref,
  watch,
  onBeforeMount,
  getCurrentInstance,
} from "@vue/composition-api";
// import test from '~@/assets/css/override-styles';

export default {
  components: {
    BPagination,
    BRow,
    BCol,
    BButton,
    ReorderIcon,
    vSelect,
    ReorderButton,
  },

  props: {
    pagination: Object,
    reordering: Boolean,
    entityEditable: Boolean,
    paginationSearch: { type: Boolean, default: true },
  },

  setup(props) {
    const vm = getCurrentInstance().proxy;
    const reorderMode = ref(false);
    const paginationConfig = reactive({
      perPageOptions: [5, 10, 25, 100],
      perPage: 10,
      currentPage: 1,
      rows: 100,
      totalRows: 100,
    });

    const initPagination = (pagination) => {
      paginationConfig.rows = pagination.rows;
      paginationConfig.totalRows = pagination.totalRows;
      paginationConfig.perPage = pagination.perPage;
      paginationConfig.currentPage = pagination.currentPage;
    };

    const paginationSearchInput = ref("");

    const onClickReorder = () => {
      reorderMode.value = !reorderMode.value;
      vm.$emit("reorder", reorderMode.value);
    };

    const searchPagination = (e) => {
      if (!paginationSearchInput.value) return;
      paginationConfig.currentPage = paginationSearchInput.value;
    };

    const onInputPaginationSearch = (e) => {
      const maxPage = Math.ceil(
        paginationConfig.totalRows / paginationConfig.perPage
      );
      vm.$nextTick(() => {
        let inputNumber = e.replace(/\D/g, "");
        if (inputNumber == "0") inputNumber = 1;
        paginationSearchInput.value =
          paginationSearchInput.value > maxPage ? maxPage : inputNumber;
      });
    };

    watch(
      () => props.pagination,
      (newVal, oldVal) => {
        initPagination(newVal);
      },
      { deep: true }
    );

    watch(
      () => paginationConfig.perPage,
      (newVal, oldVal) => {
        paginationSearchInput.value = "";
      }
    );

    onBeforeMount(() => {
      if (props.pagination) {
        initPagination(props.pagination);
      }
    });

    return {
      paginationSearchInput,
      paginationConfig,
      reorderMode,
      onClickReorder,
      searchPagination,
      onInputPaginationSearch,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/pages/dynamic-tables.css";
@import "~@/assets/css/override-styles/pagination-with-reorder.css";
</style>
